export const RELATIVE_CATEGORY_MAP = new Map([
  ['A', 'Autovettura per trasporto di persone'],
  ['B', 'Autobus per trasporto di persone'],
  ['C', 'Autocarro per trasporto di cose'],
  ['D', 'Triciclo per trasporto promiscuo'],
  ['E', 'Semirimorchio per trasporto specifico'],
  ['F', 'Triciclo per uso speciale'],
  ['G', 'Triciclo per trasporto specifico'],
  ['H', 'Semirimorchio per trasporto cose'],
  ['I', 'Autocaravan'],
  ['J', 'Rimorchio per trasporto attrezzature turistiche e sportive'],
  ['K', 'Rimorchio per trasporti specifici'],
  ['L', 'Autoveicolo per uso speciale'],
  ['M', 'Motociclo per trasporto persone'],
  ['N', 'Triciclo per trasporto cose'],
  ['O', 'Trasporto specifico persone part. condizioni'],
  ['P', 'Autoveicolo trasporto promiscuo persone/cose'],
  ['Q', 'Semirimorchio per trasporto persone'],
  ['R', 'Rimorchio per trasporto cose'],
  ['S', 'Trattore stradale per rimorchio'],
  ['SB', 'Mietitrebbia'],
  ['SC', 'Trattrice agricola cingolata'],
  ['SD', 'Trattrice agricola a 4 RM'],
  ['SE', 'Mietitrebbia eccezionale'],
  ['SM', 'Motoagricola'],
  ['SS', 'Trattrice snodata'],
  ['ST', 'Trattrice agricola a 2 rm'],
  ['T', 'Trattore per semirimorchio'],
  ['TA', 'Rimorchio agricolo – con apparecchiatura'],
  ['TB', 'Rimorchio agricolo – botte'],
  ['TC', 'Rimorchio agricolo – cassone'],
  ['TM', 'Rimorchio agricolo – asse motore'],
  ['TP', 'Rimorchio agricolo – pianale'],
  ['TR', 'Rimorchio agricolo – cassone ribaltabile'],
  ['TX', 'Macchina agricola operatrice trainata'],
  ['TY', 'Telaio per rimorchi agricoli'],
  ['U', 'Caravan'],
  ['V', 'Autoveicolo per trasporto specifico'],
  ['VA', 'Atomizzatori'],
  ['VB', 'Scavabietole'],
  ['VC', 'Motocoltivatore'],
  ['VF', 'Motofalciatrice'],
  ['VL', 'Falciacaricatrice'],
  ['VN', 'Falcia-condiziona-andanatrice'],
  ['VR', 'Motoranghinatore'],
  ['VS', 'Motoseminatrice'],
  ['VT', 'Falcia-trincia-caricatrice'],
  ['VV', 'Altre macchine'],
  ['VZ', 'Motozappatrice'],
  ['W', 'Rimorchio per trasporto persone'],
  ['X', 'Rimorchio per uso speciale'],
  ['Y', 'Semirimorchio per uso speciale'],
  ['Z', 'Triciclo per trasporto persone'],
  ['1', 'Ciclomotore'],
  ['2', 'Autoveicolo per uso speciale della Polizia Locale'],
  ['3', 'Quadriciclo per trasporto persone'],
  ['4', 'Quadriciclo per trasporto di cose'],
  ['5', 'Quadriciclo per uso speciale'],
  ['6', 'Quadriciclo trasporto specifico'],
  ['7', 'Autoveicolo in servizio pubblico di linea integrativo'],
  ['8', 'Autoveicolo uso esclusivo di polizia'],
  ['9', 'Motoveicolo uso esclusivo di polizia'],
  ['#', 'Veicolo uso speciale Autoscuola'],
  ['£', 'Quadriciclo uso esclusivo Polizia'],
  ['§', 'Uso Speciale Autoscuola']
]);

export const RELATIVE_USE_MAP = new Map([
  ['0', 'Proprio (trasporto persone)'],
  ['1', 'Di terzi da noleggio con conducente'],
  ['2', 'Di terzi da locare senza conducente'],
  ['3', 'Uso pubblico'],
  ['4', 'Proprio (trasporto cose)'],
  ['5', 'Proprio (trasporto cose)'],
  ['6', 'Di terzi con autorizzazioni vincolate'],
  ['7', 'Di terzi con autorizzazione libera'],
  ['8', 'Uso speciale'],
  ['9', 'Priv. / locazione fac. compera']
]);
